import * as yup from 'yup'
import { defineMessages } from 'react-intl'

import { DISCOUNT_TYPE } from 'features/Coupons/components/DiscountType/constants'

const companyMessages = defineMessages({
  required: {
    id: 'coupons.snacks.form.company.required',
    defaultMessage: 'The company is required'
  }
})

const campaignMessages = defineMessages({
  required: {
    id: 'coupons.snacks.form.campaign.required',
    defaultMessage: 'The campaign is required'
  }
})

const codeMessages = defineMessages({
  required: {
    id: 'coupons.snacks.form.code.required',
    defaultMessage: 'The code is required'
  },
  max: {
    id: 'coupons.snacks.form.code.max',
    defaultMessage: 'The code can be up to 10 characters'
  }
})

const startsAtMessages = defineMessages({
  required: {
    id: 'coupons.snacks.form.startsAt.required',
    defaultMessage: 'The starting date is required'
  }
})

const endsAtMessages = defineMessages({
  required: {
    id: 'coupons.snacks.form.endsAt.required',
    defaultMessage: 'The ending date is required'
  }
})

const valueMessages = defineMessages({
  required: {
    id: 'coupons.snacks.form.value.required',
    defaultMessage: 'The value is required'
  },
  max: {
    id: 'coupons.snacks.form.value.max',
    defaultMessage: 'The value can not exceed 100%'
  }
})

const limitMessages = defineMessages({
  required: {
    id: 'coupons.snacks.form.limit.required',
    defaultMessage: 'The limit is required'
  }
})

export const schema = (intl: TSFixMe): TSFixMe => {
  return yup.object().shape({
    company: yup.object().shape({
      id: yup.string().required(intl.formatMessage(companyMessages.required))
    }),
    campaign: yup.object().shape({
      id: yup.string().required(intl.formatMessage(campaignMessages.required))
    }),
    code: yup
      .string()
      .required(intl.formatMessage(codeMessages.required))
      .max(10, intl.formatMessage(codeMessages.max)),
    startsAt: yup.string().required(intl.formatMessage(startsAtMessages.required)),
    endsAt: yup.string().required(intl.formatMessage(endsAtMessages.required)),
    discountType: yup.string(),
    value: yup
      .number()
      .required(intl.formatMessage(valueMessages.required))
      .when('discountType', {
        is: DISCOUNT_TYPE.PERCENTAGE,
        then: yup.number().max(100, intl.formatMessage(valueMessages.max))
      }),
    constraints: yup.object().shape({
      minSale: yup.string(),
      limit: yup.string().required(intl.formatMessage(limitMessages.required))
    })
  })
}
